const state = () => ({
  dialogButtons: [],
  dialogHeaderType: 'none',
  dialogWidth: 492,
  showProgressBar: false,
  dialogTextClass: '',
  dialogTitle: '',
  showBackArrow: false,
  dialogContentJustify: 'start',
  dialogContentDisplayClasses: 'd-flex d-md-block'
});

const getters = {
  dialogButtons(state) {
    return state.dialogButtons;
  },
  dialogHeaderType(state) {
    return state.dialogHeaderType;
  },
  dialogWidth(state) {
    return state.dialogWidth;
  },
  showProgressBar(state) {
    return state.showProgressBar;
  },
  dialogTextClass(state) {
    return state.dialogTextClass;
  },
  dialogTitle(state) {
    return state.dialogTitle;
  },
  showBackArrow(state) {
    return state.showBackArrow;
  },
  dialogContentJustify(state) {
    return state.dialogContentJustify;
  },
  dialogContentDisplayClasses(state) {
    return state.dialogContentDisplayClasses;
  }
};

const mutations = {
  setDialogHeaderType(state, payload) {
    state.dialogHeaderType = payload;
  },
  setDialogTitle(state, payload) {
    state.dialogTitle = payload;
  },
  setDialogContentJustify(state, payload) {
    state.dialogContentJustify = payload;
  },
  setDialogContentDisplayClasses(state, payload) {
    state.dialogContentDisplayClasses = payload;
  }
};

const actions = {
  setDialogHeaderType({ commit }, payload) {
    commit('setDialogHeaderType', payload);
  },
  setDialogTitle({ commit }, payload) {
    commit('setDialogTitle', payload);
  },
  setDialogContentJustify({ commit }, payload) {
    commit('setDialogContentJustify', payload);
  },
  setDialogContentDisplayClasses({ commit }, payload) {
    commit('setDialogContentDisplayClasses', payload);
  }
};

export const iframeStep = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
